import type { ErroFoody } from "../../../services/integracaoFoodyDelivery"
import type { IntegracaoFoodyDeliveryModel } from "../models/integracaoFoodyDeliveryModel"

export enum IntegracaoFoodyDeliveryActionsTypes {
    CARREGAR = "CARREGAR",
    ATUALIZAR_TOKEN = "ATUALIZAR_TOKEN",
    ATUALIZAR_ERROS = "ATUALIZAR_ERROS",
    REGISTRAR_TESTE = "REGISTRAR_TESTE",
    LIMPAR_ERROS = "LIMPAR_ERROS",
}

type CarregarAction = {
    type: IntegracaoFoodyDeliveryActionsTypes.CARREGAR
    payload: Pick<IntegracaoFoodyDeliveryModel, "token" | "erros">
}

type AtualizarTokenAction = {
    type: IntegracaoFoodyDeliveryActionsTypes.ATUALIZAR_TOKEN
    payload: string
}

type AtualizarErrosAction = {
    type: IntegracaoFoodyDeliveryActionsTypes.ATUALIZAR_ERROS
    payload: ErroFoody[]
}

type RegistrarTesteAction = {
    type: IntegracaoFoodyDeliveryActionsTypes.REGISTRAR_TESTE
    payload: { ativa: boolean; mensagem: string; erros: ErroFoody[] }
}

type LimparErrosAction = {
    type: IntegracaoFoodyDeliveryActionsTypes.LIMPAR_ERROS
}

export type IntegracaoFoodyDeliveryActions =
    | CarregarAction
    | AtualizarTokenAction
    | AtualizarErrosAction
    | RegistrarTesteAction
    | LimparErrosAction
